import React from "react";

const WebAppIframe = (props) => {
  const src = new URL(props.src);
  const params = new URLSearchParams(window.location.search);
  params.forEach(
    (value, key) =>
      !src.searchParams.has(key) && src.searchParams.append(key, value)
  );

  return (
    <iframe
      style={{
        height: "calc(100vh - 70px)",
        border: "none",
        width: "100%",
      }}
      {...props}
      src={src.href}
    />
  );
};

export default WebAppIframe;



// WEBPACK FOOTER //
// ./src/components/WebAppIframe.js